import React, { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import Axios from 'axios';
import { useToast } from '../../../../../../hooks/toast';
import * as S from './styles';

import api from '../../../../../../services/api';
import melhorEnvioService from '../../../../../../services/melhorEnvio';
import Load from '../../../../../../newComponents/Load';

import { useAuth } from '../../../../../../hooks/auth';
import Toggle from '../../../../../../newComponents/Toggle';
import empresaApi from '../../../../../../services/empresaApi';
import useQuery from '../../../../../../hooks/useQuery';

interface IParameterDescription {
  active: boolean;
}

const MelhorEnvio: React.FC = () => {
  const query = useQuery();
  const { addToast } = useToast();
  const { user } = useAuth();

  const [token, setToken] = useState<string>();
  const [activeService, setActiveService] = useState(false);
  const authorizationUrl = `${
    process.env.REACT_APP_MELHOR_ENVIO_URL
  }/oauth/authorize?client_id=${
    process.env.REACT_APP_MELHOR_ENVIO_CLIENT_ID
  }&redirect_uri=${
    process.env.REACT_APP_MELHOR_ENVIO_REDIRECT_URI
  }&response_type=code&scope=${(
    process.env.REACT_APP_MELHOR_ENVIO_PERMISSIONS || ''
  )
    .split(',')
    .join(' ')}`;

  const handleSubmit = () => {
    const request = {
      active: activeService,
    };

    api
      .post(`/parametro`, {
        descricao: 'best_shipping_services',
        empresa_id: user.empresa_id,
        role: JSON.stringify(request),
      })
      .then((res) => {
        addToast({
          title: 'Salvo',
          type: 'success',
          description: 'Dados salvos com sucesso!',
        });
      })
      .catch(() => {
        addToast({
          title: 'Erro',
          type: 'error',
          description: 'Falha ao salvar dados. Tente novamente mais tarde.',
        });
      });
  };

  const getListServices = useCallback(() => {
    api
      .get('/parametro/loja', {
        params: {
          descricao: 'best_shipping_tokens',
          empresa_id: user.empresa_id,
        },
      })
      .then((tokenResponse) => {
        const code = query.get('code');
        const tokenParam = tokenResponse.data.role;

        if (tokenParam) {
          let tokenValue = '';

          if (typeof tokenParam === 'string') {
            tokenValue = JSON.parse(tokenParam).token;
          } else {
            tokenValue = tokenParam.token;
          }

          if (typeof tokenValue === 'string') {
            setToken(tokenValue);
          } else if (code) {
            setToken('');
          }
        } else if (code) {
          setToken('');
        }

        melhorEnvioService.getServices().then(() => {
          empresaApi
            .getParametro(user.empresa_id, 'best_shipping_services')
            .then((param) => {
              if (param) {
                const description: IParameterDescription = JSON.parse(
                  param.role,
                );

                if (description.active) setActiveService(true);
              }
            });
        });
      });
  }, [user.empresa_id, query]);

  useEffect(() => {
    getListServices();
  }, []);

  const unlinkMelhorEnvioAccount = async () => {
    api
      .post(`/parametro/loja`, {
        descricao: 'best_shipping_tokens',
        empresa_id: user.empresa_id,
        role: JSON.stringify({}),
      })
      .then(() => {
        setToken('');

        api.post(`/parametro`, {
          descricao: 'best_shipping_services',
          empresa_id: user.empresa_id,
          role: JSON.stringify({ active: activeService }),
        });

        addToast({
          title: 'Salvo',
          type: 'success',
          description: 'Conta desvinculada com sucesso!',
        });
      })
      .catch(() => {
        addToast({
          title: 'Erro',
          type: 'error',
          description: 'Falha ao salvar dados. Tente novamente mais tarde.',
        });
      });
  };

  const generateToken = async (code: string) => {
    try {
      const response = await api.post(`melhor_envio/token`, {
        code,
      });

      api
        .post(`/parametro/loja`, {
          descricao: 'best_shipping_tokens',
          empresa_id: user.empresa_id,
          role: JSON.stringify({
            token: response.data.access_token,
            refresh_token: response.data.refresh_token,
          }),
        })
        .then((res) => {
          const param = res.data.role;

          if (param) {
            if (typeof param === 'string') {
              setToken(JSON.parse(param).token);
            } else {
              setToken(param.token);
            }
          }

          addToast({
            title: 'Salvo',
            type: 'success',
            description: 'Dados salvos com sucesso!',
          });
        })
        .catch(() => {
          addToast({
            title: 'Erro',
            type: 'error',
            description: 'Falha ao salvar dados. Tente novamente mais tarde.',
          });
        });
    } catch (err) {
      addToast({
        title: 'Erro',
        type: 'error',
        description: 'Falha ao autorizar aplicativo, tente novamente',
      });
    }
  };

  useEffect(() => {
    const code = query.get('code');

    if (!token && token !== undefined && code) {
      generateToken(code);
    }
  }, [token, query]);

  return (
    <S.Container>
      <h1>Melhor Envio</h1>

      <p className="description">
        Ao habilitar este serviço, será acrescentada as opções de entrega do
        Melhor Envio.
      </p>

      {!token && (
        <>
          <Typography>
            Se não tiver uma conta no melhor envio, cadastre-se pelo botão
            abaixo:
          </Typography>

          <Button
            component={Link}
            href={process.env.REACT_APP_MELHOR_ENVIO_AFFILIATE_LINK}
            style={{
              backgroundColor: '#329BFC',
              color: '#ffffff',
              maxWidth: 300,
              marginBottom: 40,
            }}
          >
            Cadastrar
          </Button>

          <Typography>
            Caso já tenha uma conta só precisa autorizar a integração pelo botão
            abaixo:
          </Typography>

          <Button
            component={Link}
            href={authorizationUrl}
            style={{
              backgroundColor: '#329BFC',
              color: '#ffffff',
              maxWidth: 300,
            }}
          >
            Autorizar
          </Button>
        </>
      )}

      {token && (
        <>
          <Button
            onClick={unlinkMelhorEnvioAccount}
            style={{
              backgroundColor: '#329BFC',
              color: '#ffffff',
              maxWidth: 300,
              marginBottom: 40,
            }}
          >
            Desvincular conta do melhor envio
          </Button>
          <Button
            component={Link}
            href={process.env.REACT_APP_MELHOR_ENVIO_AFFILIATE_LINK}
            style={{
              backgroundColor: '#329BFC',
              color: '#ffffff',
              maxWidth: 300,
              marginBottom: 40,
            }}
          >
            Ir para a conta do melhor envio
          </Button>
          <div className="activation__container">
            <p>Habilitado:</p>

            <div
              onClick={(event) => event.stopPropagation()}
              onFocus={(event) => event.stopPropagation()}
            >
              <S.StatusSaleButton
                type="button"
                isPaused={activeService}
                className="paused"
                onClick={() => setActiveService((oldState) => !oldState)}
              >
                Desabilitado
              </S.StatusSaleButton>

              <S.StatusSaleButton
                type="button"
                isPaused={!activeService}
                className="activated"
                onClick={() => setActiveService((oldState) => !oldState)}
              >
                Habilitado
              </S.StatusSaleButton>
            </div>
          </div>
          <S.ButtonSubmit type="button" onClick={handleSubmit}>
            Salvar
          </S.ButtonSubmit>
        </>
      )}
    </S.Container>
  );
};

export default MelhorEnvio;
